import { render } from "./home-page.vue?vue&type=template&id=2655c866"
const script = {}

import "./home-page.vue?vue&type=style&index=0&id=2655c866&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__